module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/0b8922995dc031f3d524c75cde057f3d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/past-ribbons/ribbon-gold.svg
// module id = jbqH
// module chunks = 1